<template>
  <modal
    :show.sync="isActiveLocal"
    centered
    header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
    modal-content-classes="cust-medi-popup cust-overflow-y-grey"
    hide-footer
    class="overflow-y-hidden"
  >
    <div>
      <div class="mt-4">
        <p class="col-black font-semibold">First Name</p>
        <b-input
          placeholder="First Name"
          v-model="firstname"
          :disabled="true"
          class="form-control-muted mb-4"
        />
        <p class="col-black font-semibold">Last Name</p>
        <b-input
          placeholder="Last Name"
          v-model="lastname"
          class="form-control-muted mb-4"
          :disabled="true"
        />

        <p class="col-black font-semibold">Date of Birth</p>
        <base-input
          type="date"
          value="DOB"
          id="example-date-input"
          class="form-control-muted mb-4"
          placeholder="Enter Date of birth"
          v-model="DOB"
          :disabled="true"
        />
        <p class="col-black font-semibold">Gender</p>
        <b-input
          placeholder="Gender"
          v-model="gender"
          :disabled="true"
          class="form-control-muted mb-4"
        />
        <!-- <base-input class="">
          <select v-model="gender" class="form-control">
            <option>Male</option>
            <option>Female</option>
          </select>
        </base-input> -->
      </div>
      <!-- <div class="w-full">
        <p class="col-black font-semibold">Location</p>
        <b-input
          placeholder="enter location"
          class="form-control-muted mb-4"
          v-model="location"
        />
      </div> -->
      <p class="col-black font-semibold">Service Type</p>
      <b-input
        placeholder="Enter Service Type"
        class="form-control-muted mb-4"
        v-model="serviceType"
        :disabled="true"
      />
      <p class="col-black font-semibold">Service</p>
      <b-input
        placeholder="Enter Service"
        class="form-control-muted mb-4"
        v-model="service"
        :disabled="true"
      />
      <p class="col-black font-semibold">Experience</p>
      <b-input
        placeholder="Enter Experience"
        class="form-control-muted mb-4"
        v-model="experience"
        :disabled="true"
      />
      <p class="col-black font-semibold">Expertise</p>
      <b-input
        placeholder="Enter Expertise"
        class="form-control-muted mb-4"
        v-model="expertise"
        :disabled="true"
      />
      <p class="col-black font-semibold">Social Media</p>
      <b-input
        placeholder="Social Media Link"
        class="form-control-muted mb-4"
        v-model="social"
        :disabled="true"
      />
      <div>
        <!-- <p class="col-black font-semibold">Price</p>
        <b-input
          placeholder="Enter Service Amount"
          class="form-control-muted mb-4"
          v-model="price"
          :disabled="true"
        /> -->
        <p class="col-black font-semibold">Bank Name</p>
        <b-input
          placeholder="Enter Bank Name"
          class="form-control-muted mb-4"
          v-model="bankName"
          :disabled="true"
        />
        <p class="col-black font-semibold">Account Number</p>
        <b-input
          placeholder="Enter Social Account Number"
          class="form-control-muted mb-4"
          v-model="accountNumber"
          :disabled="true"
        />
        <p class="col-black font-semibold">IFSC Code</p>
        <b-input
          placeholder="Enter IFSC Code"
          class="form-control-muted mb-4"
          v-model="IFSCCode"
          :disabled="true"
        />
      </div>
      <!--   <div class="text-center">
        <b-button
          variant="primary"
          class="mr-4 mt-4"
          @click="isshowform = true"
          v-if="!isshowform"
          >close</b-button
        >
        
        <b-button variant="primary" class="mr-4 mt-4" v-if="isshowform"
          >Sumbit</b-button
        > 
      </div>-->
    </div>

    <template slot="footer" class="hidden"> <div></div> </template>
  </modal>
</template>

<script>
// import { mapState } from "vuex";
export default {
  props: {
    isActiveView: {
      type: Boolean,
      default: false,
    },

    ViewApplicationreq: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      firstname: "",
      lastname: "",
      social: "",
      gender: "",
      experience: "",
      expertise: "",
      price: "",
      DOB: "",
      location: "",
      isshowform: "",
      serviceType: "",
      service: "",
      bankName: "",
      accountNumber: "",
      IFSCCode: "",
    };
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.isActiveView;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
    // ...mapState("respitecare", ["get_volbyid"]),
  },
  watch: {
    isActiveView(val) {
      if (!val) {
        this.reset();
      }
      if (val) this.init();
      // console.log("Update");
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    init() {
      this.firstname = this.ViewApplicationreq.userId.firstname;
      this.lastname = this.ViewApplicationreq.userId.lastname;
      this.social = this.ViewApplicationreq.socialMedia;
      this.gender = this.ViewApplicationreq.gender;
      this.experience = this.ViewApplicationreq.experience;
      this.expertise = this.ViewApplicationreq.expertise;
      this.price = this.ViewApplicationreq.withdrawAmt;
      this.DOB = this.ViewApplicationreq.DOB;
      this.location = this.ViewApplicationreq.location;
      this.serviceType = this.ViewApplicationreq.serviceType;
      this.service = this.ViewApplicationreq.service;
      this.bankName = this.ViewApplicationreq.bankName;
      this.accountNumber = this.ViewApplicationreq.accountNumber;
      this.IFSCCode = this.ViewApplicationreq.IFSCCode;
    },
    reset() {
      this.firstname = "";
      this.lastname = "";
      this.social = "";
      this.gender = "";
      this.experience = "";
      this.expertise = "";
      this.price = "";
      this.DOB = "";
      this.location = "";
      this.serviceType = "";
      this.service = "";
      this.bankName = "";
      this.accountNumber = "";
      this.IFSCCode = "";
    },
  },
};
</script>

<style></style>
